import AppService from "./AppService";

/**
 * Customer-facing subscription API: available plans (with this org's discounted
 * prices), current subscription + usage, purchase/renew, billing history, and
 * cancel.
 */
class SubscriptionService {
  getAvailablePlans() {
    return AppService.get("/api/subscriptions/plans");
  }

  getCurrent() {
    return AppService.get("/api/subscriptions/current");
  }

  getUsage() {
    return AppService.get("/api/subscriptions/usage");
  }

  /**
   * Purchase/renew a plan duration. Returns { paymentUrl, activatedImmediately, ... }.
   * Redirect the browser to paymentUrl when present.
   */
  purchase(data) {
    return AppService.post("/api/subscriptions/purchase", data);
  }

  renew(data) {
    return AppService.post("/api/subscriptions/renew", data);
  }

  getPayments() {
    return AppService.get("/api/subscriptions/payments");
  }

  cancel(reason) {
    return AppService.post("/api/subscriptions/cancel", { reason });
  }

  enableAutoRenew() {
    return AppService.post("/api/subscriptions/auto-renew/enable", {});
  }

  cancelAutoRenew() {
    return AppService.post("/api/subscriptions/auto-renew/cancel", {});
  }
}

const subscriptionService = new SubscriptionService();
export default subscriptionService;
